import React from "react";
import QrCode from '../miteck/qrCode';
import PropTypes from 'prop-types';
import { consentResponse } from "../../action/application/consentResponse";
import { frontEndLogs } from "../../action/logs/frontEndLogs";
import { analyticsClickEvent } from "../../action/firebaseAnalytics/firebaseAnalytics";

export class MitekConsent extends React.Component {

  consentResponseButton = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const applicationId = urlParams.get('applicationID') || await this.props.getApplicationIDInstorage();
    const consentClickedResponse = await consentResponse({ applicationId });
    frontEndLogs('Application Consent and Conent Button Clicked', false, 200, 'getUserValidated', consentClickedResponse);
    analyticsClickEvent('consent_and_continue_button_clicked', '')
  };

  render() {
    const { isBrokerApplication, showQRCode, applicationConsentSrc, isBioConsentShown, disableApplicationConsentButton, phoneNo, width, divRef, qrRef, handleInputChange, getBrokerUserDetails, getConsentStatus, handleScrollMitekConsentPage, handleLoaderStatus, isEnableDesktopCapture, checkMitekToken, mitekVerificationLinkForUser, handleQrCode, sendButtonDisable } = this.props;
    return (
      <div className="broker-consent" ref={divRef}>
        <div className='broker-consent-page container' id='mitekConsentScreenScroll'>
          <div className='row'>
            <div className='col-md-6 broker-screen-section align-items-center'>
              <div className='broker-image-section'>
                <img src="images/broker-image.png" alt="" />
              </div>
            </div>
            <div className={`col-md-6 broker-consent-text align-items-center ${showQRCode ? 'height-changed' : ''}`}>
              <div className="verfication-text">
                <div className='broker-consent-section-heading'>
                  Let's Confirm It's You
                </div>
                <p className='text-left d-block mb-2' style={{ color: "#979797" }}>
                  To verify your identity securely, we need your consent to share and process your facial image data with our trusted partner, Mitek. This is necessary to ensure accurate and safe identity verification. Your data will be handled securely and used only for this purpose.
                  <br />
                  <br />
                  You can review Mitek's <a href="https://www.miteksystems.com/privacy-policy" target='_blank' rel="noopener noreferrer"
                    className='apply-important-info-link' id="privacy-policy-link">
                    Privacy Policy</a> to understand how your data will be handled.
                  <br />
                  <br />
                  Please check the box below to confirm your agreement to the processing of your data by Mitek and humm.
                </p>
                <br />
                <div className='brokerConsent--button-group py-md-3'>
                  <div className="app-form-check form-group">
                    <button onChange={handleInputChange}>
                      <img
                        className="checkBox"
                        src={applicationConsentSrc}
                        alt="checkbox"
                        name="applicationConsentRadio"
                        value={isBioConsentShown}
                        style={{ cursor: 'pointer' }}
                        disabled={isBioConsentShown}
                      />
                      <label
                        htmlFor="applicationConsentRadio"
                        className="radio-label"
                        style={{ color: "#979797", cursor: 'pointer' }}
                      >
                        I agree to the processing of my data by Mitek and humm for the purpose of identity verification.
                      </label>
                    </button>
                    <input
                      type="checkbox"
                      name="applicationConsentRadio"
                      id="applicationConsentRadio"
                      className="app-form-check-input"
                      checked={sessionStorage.getItem('applicationConsent') === 'true'}
                      onChange={handleInputChange}
                      disabled={isBioConsentShown}
                    />
                  </div>
                </div>
              </div>

              <div className="consent-btn text-center">
                <button
                  type="button"
                  disabled={isBioConsentShown || disableApplicationConsentButton}
                  className="btn btn-warning btn-fill"
                  id="broker-btn"
                  onClick={() => {
                    if (isBrokerApplication || sessionStorage.getItem('brokerFlow') == 'true') {
                      getBrokerUserDetails();
                    }
                    handleQrCode();
                    setTimeout(() => {
                      this.consentResponseButton();
                      getConsentStatus();
                      handleScrollMitekConsentPage();
                    }, 300);
                  }}
                  style={{ cursor: (isBioConsentShown || disableApplicationConsentButton) ? 'not-allowed' : 'pointer' }}
                >
                  Consent and Continue
                </button>
              </div>
            </div>
          </div>
          {showQRCode && (
            <div className='row'>
              <div className='col-md-6 col-sm-0'></div>
              <div className='col-md-6 col-sm-12 justify-content-center'>
                <div className='ml-lg-5 pl-lg-5'>
                  <div className='d-flex align-items-center justify-content-center'>
                    <div className='qrcode-consent-text mb-4'>
                      Scan the QR code below using your mobile device or enter your mobile number to complete this step. Please have your passport or driving licence ready for verification.
                    </div>
                  </div>
                  <div className="mitek-consent-page-two-section container" style={{ backgroundColor: '#F1F2EE' }}>

                    <div className={`${width <= 1268 ? 'd-block' : 'd-flex'} justify-content-around align-items-center`}>
                      <div className='qrcode-display'>
                        {showQRCode === true && (
                          <div className='qrcode-option'>
                            <QrCode ref={qrRef} handleLoader={handleLoaderStatus} enableWebCapture={isEnableDesktopCapture} mitekTokenValue={checkMitekToken} />
                          </div>
                        )}
                      </div>

                      <div className='separate-section'>
                        <span className='vertical-line'></span>
                        <h3 className='or-subtext'>OR</h3>
                        <span className='vertical-line'></span>
                      </div>

                      <div
                        className={`smslink-option ${width <= 1268 ? 'mt-4' : ''}`}
                        style={{ width: width <= 1268 ? 'auto' : '250px' }}>
                        <form>
                          <div className="form-group identity-doc-form">
                            <label htmlFor="phoneNumber" className='text-left d-block mb-2'>Phone Number </label>
                            <input
                              type="text"
                              id='phoneNumber'
                              value={phoneNo}
                              name="phoneNo"
                              disabled={phoneNo !== ''}
                              className="form-control"
                              placeholder="Enter here"
                            />
                          </div>
                        </form>

                        <div className="next-btn text-center">
                          <button
                            type="button"
                            style={{ backgroundColor: "#ff6c00" }}
                            disabled={sendButtonDisable}
                            className="btn btn-primary"
                            id="btn-one"
                            onClick={() => { mitekVerificationLinkForUser() }}
                          >
                            Send
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

MitekConsent.propTypes = {
  isBrokerApplication: PropTypes.bool,
  showQRCode: PropTypes.bool,
  applicationConsentSrc: PropTypes.any,
  isBioConsentShown: PropTypes.bool,
  disableApplicationConsentButton: PropTypes.bool,
  phoneNo: PropTypes.any,
  width: PropTypes.any,
  divRef: PropTypes.any,
  qrRef: PropTypes.any,
  handleInputChange: PropTypes.func,
  getBrokerUserDetails: PropTypes.any,
  getConsentStatus: PropTypes.func,
  handleScrollMitekConsentPage: PropTypes.func,
  handleLoaderStatus: PropTypes.func,
  isEnableDesktopCapture: PropTypes.bool,
  checkMitekToken: PropTypes.func,
  mitekVerificationLinkForUser: PropTypes.func,
  handleQrCode: PropTypes.func,
  sendButtonDisable: PropTypes.bool,
  getApplicationIDInstorage: PropTypes.func

}